import { render } from "./UpdateForm.vue?vue&type=template&id=2ad89eba&scoped=true"
import script from "./UpdateForm.vue?vue&type=script&lang=js"
export * from "./UpdateForm.vue?vue&type=script&lang=js"

import "./UpdateForm.vue?vue&type=style&index=0&id=2ad89eba&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ad89eba"

export default script